// import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// @Injectable({ providedIn: 'root' })
// export class UserProfileService {
//     constructor(private http: HttpClient) { }

//     getAll() {
//         return this.http.get<User[]>(`/api/login`);
//     }

//     register(user: User) {
//         return this.http.post(`/users/register`, user);
//     }
// }

@Injectable({ providedIn: 'root' })
export class MenuItemList {
  selection: any;
  simpleObservable = new Observable((observer) => {
    switch (this.selection) {

     

        case 'admin':
          observer.next([
            {
              id: 79,
              label: 'Dashboard', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/admin/dashboard',
              icon: 'bx bx-line-chart',
              parentId: 7,
            },
            {
              id: 71,
              label: 'Staff', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/admin/staff',
              icon: 'bx bx-user',
              parentId: 7,
            },
            {
              id: 3,
              label: 'Setup', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bx-cog',
              subItems: [
                
                {
                  id: 72,
                  label: 'Categories', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/admin/categories',
                  parentId: 7,
                },
                {
                  id: 75,
                  label: 'Process-Objective',
                  link: '/admin/process_objective',
                },
                
                {
                  id: 76,
                  label: 'Objective-Control',
                  link: '/admin/objectivecontrol',
                },
              
                {
                  id: 76,
                  label: 'Control-Test',
                  link: '/admin/control',
                },
                {
                  id: 76,
                  label: 'Test-Document',
                  link: '/headnew/testdocument',
                },
                // {
                //   id: 76,
                //   label: 'Target-Measure',
                //   link: '/admin/targetmeasure',
                // },
                // {
                //   id: 206,
                //   label: 'Appraiser-Appraisee', 
                //   link: '/headnew/appraisermapping',
                // },
                
               
              ],
            },
            {
              id: 76,
              label: 'Files',
              icon: 'bx bx-file',
              link: '/admin/files',
            },

        
          ]);
          break;

      
          observer.next([
            {
              id: 196,
              label: 'Dashboard',
              icon: 'bx bx-calendar-check',
              link: '/super/dashboard',
            },
            {
              id: 196,
              label: 'Work Assignment',
              icon: 'bx bx-calendar-check',
              link: '/super/work-assign',
            },
           
            {
              id: 198,
              label: 'View Work', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/super/issues',
              icon: 'bx bx-calendar-check',
            },
           
            {
              id: 3,
              label: 'Appraisals', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bxs-report',
              subItems: [
                
                {
                  id: 42,
                  label: 'Appraiser Work', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/super/appraiser',
                  parentId: 7,
                },
                {
                  id: 43,
                  label: 'My Appraisal', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/super/perform_appraisal',
                  parentId: 7,
                },
                
               
              ],
            }, {
              id: 198,
              label: 'Files', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/super/files',
              icon: 'bx bx-file',
            },
        
          ]);
          break;

        case 'staff':
            observer.next([
              {
                id: 204,
                label: 'Dashboard',
                icon: 'bx bx-line-chart',
                link: '/staff/dashboard',
              },
             
             
              
              {
                id: 3,
                label: 'Work', //'MENUITEMS.ECOMMERCE.TEXT',
                icon: 'bx bx-notepad',
                subItems: [
                  {
                    id: 205,
                    label: 'Staff Assignment',
                  
                    link: '/staff/work-assign',
                  },
                  {
                    id: 205,
                    label: 'Execute',
                  
                    link: '/staff/work',
                  },
                  {
                    id: 206,
                    label: 'View Work', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                    link: '/staff/issues',
                   
                  },
                  {
                    id: 206,
                    label: 'Observation', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                    link: '/staff/observation',
                  
                  },
                 
                ],
              },
              {
                id: 3,
                label: 'Appraisals', //'MENUITEMS.ECOMMERCE.TEXT',
                icon: 'bx bx-card',
                subItems: [
                  
                  {
                    id: 42,
                    label: 'My Appraisals', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                    link: '/staff/appraiser',
                    parentId: 7,
                  },
                  {
                    id: 43,
                    label: 'My Appraisal', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                    link: '/staff/perform_appraisal',
                    parentId: 7,
                  },
                  
                 
                ],
              },
              {
                id: 206,
                label: 'Files', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                link: '/staff/files',
                icon: 'bx bx-file',
              },
          
            ]);
            break;

        case 'headnew':
          observer.next([
            {
              id: 199,
              label: 'Dashboard', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/headnew/dashboard',
              icon: 'bx bx-line-chart',
            },
            {
              id: 197,
              label: 'Team Creation', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/headnew/team',
              icon: 'bx bx-share-alt',
            },
           
          

             
            {
              id: 3,
              label: 'Work', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bx-notepad',
              subItems: [
                
                {
                  id: 298,
                  label: 'Work Assignment', 
                  //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
             
                  link: '/headnew/work_setup',
                 
                },
                {
                  id: 299,
                  label: 'View Work', 
               
                  link: '/headnew/work',
                
                },
                {
                  id: 299,
                  label: 'Observation', 
             
                  link: '/headnew/observation',
                
                },
               
              ],
            },
           
           
            
            {
              id: 3,
              label: 'Appraisals', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bx-card',
              subItems: [
                
                {
                  id: 42,
                  label: 'My Appraisals', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/headnew/appraiser',
                  parentId: 7,
                },
                {
                  id: 43,
                  label: 'Dept Appraisals', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/headnew/perform_appraisal',
                  parentId: 7,
                },
                
               
              ],
            },
            {
              id: 299,
              label: 'Files', 
              icon: 'bx bx-file',//'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/headnew/files',
            
            },
            {
              id: 206,
              label: 'Grant Access', 
              icon: 'bx bx-user',
              link: '/headnew/user',
            },
            {
              id: 3,
              label: 'Setup', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bx-cog',
              subItems: [
                
                    {
                  id: 72,
                  label: 'Categories', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/headnew/categories',
                  parentId: 7,
                },
                {
                  id: 75,
                  label: 'Process-Objective',
                  link: '/headnew/process_objective',
                },
                
                {
                  id: 76,
                  label: 'Objective-Control',
                  link: '/headnew/objectivecontrol',
                },
                // {
                //   id: 75,
                //   label: 'Process-Test',
                //   link: '/headnew/process_test',
                // },
                {
                  id: 76,
                  label: 'Control-Test',
                  link: '/headnew/control',
                },
                {
                  id: 76,
                  label: 'Test-Document',
                  link: '/headnew/testdocument',
                },
                {
                  id: 76,
                  label: 'Target-Measure',
                  link: '/headnew/targetmeasure',
                },
                {
                  id: 206,
                  label: 'Appraiser-Appraisee', 
                  link: '/headnew/appraisermapping',
                },
                
               
              ],
            }
  
          ]);
          break;



      
          observer.next([
            {
              id: 1,
              label: 'MENUITEMS.MENU.TEXT',
              isTitle: true,
            },
            {
              id: 3,
              label: 'Work', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bxs-report',
              subItems: [
                
                {
                  id: 42,
                  label: 'View Data', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
                  link: '/lbcdata/collection',
                  parentId: 7,
                }
               
              ],
            },
  
        
  
          
          ]);
break;

        case 'sectorhead':
          observer.next([
            {
              id: 199,
              label: 'Dashboard', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/dashboard',
              icon: 'bx bx-line-chart',
            },
            {
              id: 71,
              label: 'Staff', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/staff',
              icon: 'bx bx-user',
              parentId: 7,
            },
            {
              id: 197,
              label: 'Grant Access', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/user',
              icon: 'bx bx-user',
            },
            {
              id: 197,
              label: 'Team', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/team',
              icon: 'bx bx-group',
            },
       

             
            {
              id: 3,
              label: 'Work', //'MENUITEMS.ECOMMERCE.TEXT',
              icon: 'bx bxs-report',
              subItems: [
                
              
                {
                  id: 299,
                  label: 'View Work', 
               
                  link: '/sectorhead/work',
                
                },
                {
                  id: 299,
                  label: 'Observation', 
             
                  link: '/sectorhead/observation',
                
                },
               
              ],
            },
           
           
            
            {
              id: 43,
              label: 'Appraisal', //'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/appraisal',
              icon: 'bx bx-card',//'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              parentId: 7,
            },
            {
              id: 299,
              label: 'Files', 
              icon: 'bx bx-file',//'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
              link: '/sectorhead/files',
            
            },
          
            // ,
            // {
            //   id: 299,
            //   label: 'Log', 
            //   icon: 'bx bx-user',//'MENUITEMS.ECOMMERCE.LIST.PRODUCTS',
            //   link: '/sectorhead/log',
            
            // }
        
        
  
          ]);
          break;
    }
    observer.complete();
  });
  //   constructor(private auth: AuthService, private router: Router) {
  //     if (!auth.isLoggedIn()) {
  //       router.navigate(['/auth/login']);
  //     }
  //   }

  constructor(private router: Router) {
    // if (!auth.isLoggedIn()) {
    //   router.navigate(['/auth/login']);
    // }
  }

  menu(menuList) {
    this.selection = menuList;
    return this.simpleObservable;
  }
}
